const state = {
  isRepAuthenticated: false,
  landingInfo: null,
  landingUrl: null,
  repInfo: null,
  groupInfo: null,
  isEmployeeEnrollment:false,
  isContinueEnrollmentLandingPage: false,
  isPatriotOver65: false,
  isGroupViewPlans: false,
  employeeGroupCode: '',
  isInnerLandingRedirection: false,
  isLandingDirectRedirection: false
}

const mutations = {
  setRepAuthenticatedState: (state, payload) => {
    state.isRepAuthenticated = payload
  },
  setLandingInfo: (state, payload) => {
    state.landingInfo = payload
  },
  setLandingUrl: (state, payload) => {
    state.landingUrl = payload
  },
  setRepInfo: (state, payload) => {
    state.repInfo = payload
  },
  setGroupInfo: (state, payload) => {
    state.groupInfo = payload
  },
  setEmployeeEnrollmentState: (state, payload) => {
    state.isEmployeeEnrollment = payload
  },
  setEmployeeGroupCode: (state, payload) => {
    state.employeeGroupCode = payload
  },
  setContinueEnrollmentFlag: (state, payload) => {
    state.isContinueEnrollmentLandingPage = payload
  },
  setPatriotAgeStatus: (state, payload) => {
    state.isPatriotOver65 = payload
  },
  setGroupViewPlans: (state, payload) => {
    state.isGroupViewPlans = payload
  },
  setInnerLandingStatus: (state, payload) => {
    state.isInnerLandingRedirection = payload
  },
  setLandingDirectRedirectionStatus: (state, payload) => {
    state.isLandingDirectRedirection = payload
  },
}

const actions = {
  isEmployeeEnrollment: ({commit}, payload) => {
    commit('setEmployeeEnrollmentState', payload)
  },
  isRepAuthenticated: ({commit}, payload) => {
    commit('setRepAuthenticatedState', payload)
  },
  landingInfo: ({commit}, payload) => {
    commit('setLandingInfo', payload)
  },
  landingUrl: ({commit}, payload) => {
    commit('setLandingUrl', payload)
  },
  repInfo: ({commit}, payload) => {
    commit('setRepInfo', payload)
  },
  groupInfo: ({commit}, payload) => {
    commit('setGroupInfo', payload)
  },
  continueEnrollmentInfo: ({commit}, payload) => {
    commit('setContinueEnrollmentFlag', payload)
  },
  isPatriotOver65: ({commit}, payload) => {
    commit('setPatriotAgeStatus', payload)
  },
  isGroupViewPlans: ({commit}, payload) => {
    commit('setGroupViewPlans', payload)
  },
  employeeGroupCode: ({commit}, payload) => {
    commit('setEmployeeGroupCode', payload)
  },
  innerLandingRedirection: ({commit}, payload) => {
    commit('setInnerLandingStatus', payload)
  },
  isLandingDirectRedirection: ({commit}, payload) => {
    commit('setLandingDirectRedirectionStatus', payload)
  }
}

export default {
  state,
  mutations,
  actions
}
